import React from 'react';
import { Field, useFormikContext } from 'formik';

import { FormErrorUI, FormLabelUI, AutoCompleteSelectUI, CheckboxUI } from '../Interface';

const ItemOtherPropsTab = ({ viewField, autocompleteOptions }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();
  return (
    <div className="grid grid-cols-2 gap-x-4 mx-4 mb-5">
      <div className="col-span-2 md:col-span-1">
        <Field
          type="autocomplete"
          name="purchaseVatCode"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Beszerzés ÁFA kód" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.purchaseVatCode} />}
          onChange={(_e, newVal) => {
            setFieldValue('purchaseVatCode', newVal?.value ?? null).then(() => {
              validateField('purchaseVatCode');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.purchaseVatCode !== null }}
          selectedValue={values.purchaseVatCode}
          selectedLabelValue={
            autocompleteOptions?.purchaseVatCode?.find((opt) => opt.value === values.purchaseVatCode)?.name
          }
          dataset={autocompleteOptions?.purchaseVatCode}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="salesVatCode"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Értékesítés ÁFA kód" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.salesVatCode} />}
          onChange={(_e, newVal) => {
            setFieldValue('salesVatCode', newVal?.value ?? null).then(() => {
              validateField('salesVatCode');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.salesVatCode !== null }}
          selectedValue={values.salesVatCode}
          selectedLabelValue={autocompleteOptions?.salesVatCode?.find((opt) => opt.value === values.salesVatCode)?.name}
          dataset={autocompleteOptions?.salesVatCode}
        />
      </div>
      <div className="col-span-2 md:col-span-1">
        <Field
          name="landedCost"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Mellékköltség" />}
          helperText={<FormErrorUI message={errors?.landedCost} />}
          disabled={viewField || values.type !== 'SERVICE'}
        />
      </div>
    </div>
  );
};

export default ItemOtherPropsTab;
